/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "portal": {
        "nested": {
          "service": {
            "nested": {
              "SubmitPortalTransactionError": {
                "nested": {
                  "SubmitPortalTransactionErrorType": {
                    "values": {
                      "DEFAULT_CREATION_ERROR_DO_NOT_USE": 0,
                      "INVALID_REQUEST": 1,
                      "INVALID_STATE": 2,
                      "INTERNAL_ERROR": 3
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.portal?.nested?.service?.nested?.SubmitPortalTransactionError?.nested?.SubmitPortalTransactionErrorType) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SubmitPortalTransactionError @ squareup/portal/service.proto at 96:1
 */
export const SubmitPortalTransactionError = {};
/**
 * Enum of the submit portal transaction error types.
 *
 * SOURCE SubmitPortalTransactionErrorType @ squareup/portal/service.proto at 104:3
 */
SubmitPortalTransactionError.SubmitPortalTransactionErrorType = $root.lookupEnum('squareup.portal.service.SubmitPortalTransactionError.SubmitPortalTransactionErrorType').values;